import type { ILocalizedMetadata } from '@/services';

export const translateMetadata = (data: ILocalizedMetadata[] | undefined): ILocalizedMetadata | undefined => {
  const activeLocale = localStorage.getItem('locale') || 'en-US';

  if (data) {
    const activeLocalization = data.find((l) => l.locale === activeLocale);
    if (activeLocalization) {
      return activeLocalization;
    }

    if (data.length > 0) {
      return data[0];
    }
  }
};
